import React from 'react';
import Button from 'components/ui/Button';


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const canGoPrevious = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div className="flex items-center justify-between bg-white rounded-lg border border-gray-200 px-6 py-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!canGoPrevious}
        iconName="ChevronLeft"
      >
        Precedente
      </Button>
      
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600">
          Pagina <span className="font-semibold">{currentPage}</span> di <span className="font-semibold">{totalPages}</span>
        </span>
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!canGoNext}
        iconName="ChevronRight"
        iconPosition="right"
      >
        Successiva
      </Button>
    </div>
  );
};

export default Pagination;